(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pac-brand-directory"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pac-brands]').forEach((directory) => {
    const search = directory.querySelector('[data-brand-search]');
    const cards = Array.from(directory.querySelectorAll('[data-brand-card]'));
    const groups = Array.from(directory.querySelectorAll('[data-brand-group]'));
    const letters = Array.from(directory.querySelectorAll('[data-brand-letter]'));
    const empty = directory.querySelector('[data-brand-empty]');
    const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
    letters.forEach((letter) => {
      letter.addEventListener('click', (event) => {
        letters.forEach((item) => { item.classList.remove('is-current'); item.removeAttribute('aria-current'); });
        letter.classList.add('is-current');
        letter.setAttribute('aria-current', 'location');
        const target = document.getElementById(letter.dataset.brandLetter);
        if (target && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', letter.getAttribute('href'));
        }
      });
    });
    const aliases = { 'Yves Saint Laurent': 'ysl', 'Jean Paul Gaultier': 'jpg', 'Parfums de Marly': 'pdm', 'Dolce & Gabbana': 'dg' };
    search.addEventListener('input', () => {
      const query = normalize(search.value.trim());
      let visible = 0;
      cards.forEach((card) => {
        const name = card.dataset.brandName;
        const match = normalize(name + ' ' + (aliases[name] || '')).includes(query);
        card.hidden = !match;
        if (match) visible += 1;
      });
      groups.forEach((group) => { group.hidden = !group.querySelector('[data-brand-card]:not([hidden])'); });
      letters.forEach((letter) => { letter.hidden = document.getElementById(letter.dataset.brandLetter).hidden; });
      empty.hidden = visible > 0;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
